(() => {
  if (customElements.get('trt-competition-gallery')) return;
  customElements.define('trt-competition-gallery', class extends HTMLElement {
    connectedCallback() {
      this.start();
      if (!this._cleanup && !this._pending) {
        this._pending = new MutationObserver(() => this.start());
        this._pending.observe(this, { childList: true, subtree: true });
      }
    }
    start() {
      if (!this.isConnected || this._cleanup) return;
      const stage = this.querySelector('.competition-auto-stage');
      const track = this.querySelector('.competition-slide-track');
      const photos = track ? Array.from(track.querySelectorAll('img')) : [];
      if (!stage || !track || photos.length < 2) return;
      if (this._pending) { this._pending.disconnect(); this._pending = null; }
      const dots = Array.from(this.querySelectorAll('.competition-slide-indicators span'));
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const cleanups = [];
      let index = 0, timer = null, startX = null, startY = null;
      const listen = (target, name, handler, options) => {
        target.addEventListener(name, handler, options);
        cleanups.push(() => target.removeEventListener(name, handler, options));
      };
      const show = next => {
        index = (next + photos.length) % photos.length;
        track.style.transform = `translate3d(-${index * 100}%, 0, 0)`;
        photos.forEach((photo, i) => photo.setAttribute('aria-hidden', String(i !== index)));
        dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
      };
      const stop = () => { if (timer !== null) { clearInterval(timer); timer = null; } };
      const resume = () => {
        stop();
        if (!motion.matches && !document.hidden && this.isConnected) timer = setInterval(() => show(index + 1), 4500);
      };
      listen(stage, 'keydown', event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault(); show(index + (event.key === 'ArrowRight' ? 1 : -1)); resume();
        }
      });
      listen(stage, 'touchstart', event => {
        startX = event.touches[0].clientX; startY = event.touches[0].clientY; stop();
      }, { passive: true });
      listen(stage, 'touchend', event => {
        if (startX !== null && event.changedTouches.length) {
          const dx = event.changedTouches[0].clientX - startX;
          const dy = event.changedTouches[0].clientY - startY;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) show(index + (dx < 0 ? 1 : -1));
        }
        startX = startY = null; resume();
      }, { passive: true });
      listen(stage, 'touchcancel', () => { startX = startY = null; resume(); }, { passive: true });
      listen(document, 'visibilitychange', resume);
      if (motion.addEventListener) listen(motion, 'change', resume);
      else { motion.addListener(resume); cleanups.push(() => motion.removeListener(resume)); }
      this._cleanup = () => { stop(); cleanups.forEach(cleanup => cleanup()); };
      show(0); resume();
    }
    disconnectedCallback() {
      if (this._pending) { this._pending.disconnect(); this._pending = null; }
      if (this._cleanup) { this._cleanup(); this._cleanup = null; }
    }
  });
})();
